module.exports = __webpack_public_path__ + "img/unchecked2.35edf92b.png";